import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  openToast: ['data'],
  closeToast: []
});

const INITIAL_STATE: any = {
  icon: '',
  text: '',
  buttonLabel: '',
  actionButton: undefined,
  buttonActionLabel: undefined,
  component: undefined
};

const openToast = (state = INITIAL_STATE, action: any) => ({
  ...action.data, show: true
});


const closeToast = (state = INITIAL_STATE, action: any) => ({
  ...state, show: false
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_TOAST as any]: openToast,
  [Types.CLOSE_TOAST as any]: closeToast
});